module.exports = __webpack_public_path__ + "a1ad68a6dea44246c1ed7b61e7d72fd9.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ../images/speakers/alejandro-oviedo.jpg
 ** module id = 398
 ** module chunks = 0
 **/